module.exports = __webpack_public_path__ + "static/media/ic_undo.e9cd5e3d.svg";